import type { MeetingThread } from "../services/meetingThread";
import type { CalEvent } from "../types";
import { useLoadedOnce } from "./useLoadedOnce";

/** Threads read this session, per meeting and subject; null where there's none. */
const cache = new Map<string, MeetingThread | null>();

/** Each meeting's latest email thread, by event id, for its "Mail ·" tag and Linked Material; left out until found. */
export function useMeetingThreads(
  load: (event: CalEvent) => Promise<MeetingThread | null>,
  events: readonly CalEvent[],
): ReadonlyMap<string, MeetingThread> {
  const items = events.map((e) => ({ key: `${e.id}|${e.subject}`, id: e.id, load: () => load(e) }));
  return useLoadedOnce(cache, items, "load-row-thread");
}
